import {getClinicianAssessmentScores} from "@shared/GenericTools/ClinicianAssessmentModel.js";

export const CY_BOCS_II_IDENTITY = "CY-BOCS-II Clinical Version (2011)";

const instrumentContent = {
	"checklist": [
		{
			"number": 1,
			"text": "Excessive concern with germs. Examples: AIDS, diseases, or contracting illness."
		},
		{
			"number": 2,
			"text": "Excessive concern with contaminants or chemicals. Examples: household cleansers, gasoline, radiation, pesticides and chemicals."
		},
		{
			"number": 3,
			"text": "Concern will harm others by spreading germs or contaminants. Examples: transfer germs from one object to another."
		},
		{
			"number": 4,
			"text": "Bothered by bodily waste or fluids. Examples: sweat, urine, feces, saliva or blood."
		},
		{
			"number": 5,
			"text": "Bothered by sticky substances or residues. Examples: adhesives, chalk dust, or grease."
		},
		{
			"number": 6,
			"text": "Excessive concern with becoming pregnant or of making someone pregnant. This question may not be relevant for younger children (11 years and younger). Example: Woman afraid of conception if she swims in public pool."
		},
		{
			"number": 7,
			"text": "Concerned with having an illness or disease or getting sick.* Examples: getting the flu or a disease. It is not always clear where to draw the line between somatic obsessions and the somatic preoccupations of *hypochondriasis. Factors that point to OCD are the presence of compulsions not limited to seeking reassurance."
		},
		{
			"number": 8,
			"text": "Fear of eating certain foods.* Examples: excessive concern about risks of certain foods or food preparations, afraid will choke, food will change body chemistry. *Distinguish from anorexia nervosa, in which concern is gaining weight/body image."
		},
		{
			"number": 9,
			"text": "Fear might harm self or others because not careful enough. Examples: irrational fear that if don’t pick up toys that caregiver will trip on them and get seriously injured."
		},
		{
			"number": 10,
			"text": "Fear might harm self or others on impulse.* Examples: physically harming loved ones, stabbing or poisoning parents, pushing sibling in front of a car. *Distinguish from homicidal/suicidal intent."
		},
		{
			"number": 11,
			"text": "Fear of being responsible for terrible events. Examples: fire, burglary, flooding house, parents divorcing, caregiver dying."
		},
		{
			"number": 12,
			"text": "Fear of blurting out obscenities or insults. Examples: shouting blasphemies in church, yelling fire in the movie theatre, writing obscenities in a school paper."
		},
		{
			"number": 13,
			"text": "Fear of doing something else embarrassing or inappropriate.* Examples: sexual contact, spitting, taking off clothes in public, stealing things. *Distinguish from social phobia."
		},
		{
			"number": 14,
			"text": "Violent, horrific or repulsive images. Examples: intrusive and disturbing images of car crashes or disfigured people. * Distinguish from PTSD."
		},
		{
			"number": 15,
			"text": "Excessive concern with right/wrong or scrupulosity. Examples: worries about always doing “the right thing”, unfounded worries about lying or cheating (e.g., on a test), didn’t say prayers perfectly."
		},
		{
			"number": 16,
			"text": "Concern with sacrilege or blasphemy. Examples: intrusive unacceptable thoughts or images about God or religion. Concerns about adherence to religious principles exceeding those of religious peer group."
		},
		{
			"number": 17,
			"text": "Excessive fears of Satan or demonic possession. Examples: the devil will possess my soul, sports teams with word devil in them, “666”, pentangles."
		},
		{
			"number": 18,
			"text": "Forbidden or improper sexual thoughts or images.* Examples: unwanted sexual thoughts about family members or others; images of unacceptable acts; repetitive thoughts of sexual words/content. *Distinguish from paraphilias by asking about fantasy life. (This question may not be relevant for younger children)."
		},
		{
			"number": 19,
			"text": "Experiences unwanted sexual impulses.* Examples: concerned that might “snap” and commit inappropriate sexual behavior such as grab someone. *Distinguish from paraphilias. (This question may not be relevant for younger children)"
		},
		{
			"number": 20,
			"text": "Excessive concerns about sexual orientation or gender identity. Examples: child repeatedly wonders if s/he is gay even though there is every reason to believes s/he is heterosexual. *Distinguish from realistic issues around sexual or gender identity. This question may not be relevant for younger children"
		},
		{
			"number": 21,
			"text": "Need for symmetry or exactness. Examples: certain things can’t be touched or moved, toys or books organized in particular manner, bothered if pictures are not straight or toys not lined up."
		},
		{
			"number": 22,
			"text": "Perfection in appearance or grooming. Examples: excessive concern about appearance of clothing, such as wrinkles, lint, loose threads; bothered if hair not arranged perfectly."
		},
		{
			"number": 23,
			"text": "Fear of saying the wrong thing. Example: child may appear to have thought blocking because he/she is reviewing potential interpretation of what he/she is about to say. Expresses doubt when giving relatively straight forward responses."
		},
		{
			"number": 24,
			"text": "Excessively bothered by things not sounding \"just right.\" Examples: readjusting stereo system until it sounds \"just right\"; asks family members to say things in just the right way, excessively bothered by visual, auditory or somatic sensations of not being ‘just right.’"
		},
		{
			"number": 25,
			"text": "Need to know or remember. Examples: needing to remember insignificant things like license plate numbers, bumper stickers, advertising slogans, packaging information."
		},
		{
			"number": 26,
			"text": "Need to hoard or save things.* Examples: afraid that something valuable might be discarded with recycled newspapers even though all valuables are locked up in the safe. Also may be concerned over loss of valuable piece of information if papers/items are discarded. *Distinguish from hobbies and concern with objects of monetary or sentimental value."
		},
		{
			"number": 27,
			"text": "Fear of losing objects, information, or a person. Examples: Child concerned that her “soul” would be changed by engaging in a certain behavior, or may be afraid that dog will be taken from yard while at school."
		},
		{
			"number": 28,
			"text": "Magical or Superstitious Fears. Examples: colors with special significance (black connected with death, red associated with blood and injury), black cats, stepping on side walk cracks, lucky and unlucky numbers."
		},
		{
			"number": 29,
			"text": "Intrusive Meaningless Sounds, Words, or Music. Examples: songs or music with no special significance play over and over in one's mind like a broken record."
		},
		{
			"number": 30,
			"text": "Excessive or ritualized hygiene. Examples: washes hands like surgeon scrubbing for the operating room, uses harsh detergents or very hot water; takes long ritualized showers; excessive tooth brushing or toilet routine."
		},
		{
			"number": 31,
			"text": "Cleaning of household items, inanimate objects or pets. Examples: cleaning toys excessively; daily thorough washing of pets or school materials, asks for excessive washing of clothes."
		},
		{
			"number": 32,
			"text": "Checking locks, stove, appliances, faucets, etc. Examples: Checking that the doors are locked, stove is turned off, appliances unplugged."
		},
		{
			"number": 33,
			"text": "Checking that nothing terrible did/will happen. Examples: when returning home from school, check to make sure parent or pet did not die while they were at school"
		},
		{
			"number": 34,
			"text": "Checking that did not make mistake. Examples: homework, counting money, writing."
		},
		{
			"number": 35,
			"text": "Checking tied to somatic obsessions.* Examples: repeatedly checking body for signs of skin cancer; asking family members for reassurance about health. *Distinguish from hypochondriasis."
		},
		{
			"number": 36,
			"text": "Need to repeat routine activities or boundary crossings. Examples: going through doorway; may get stuck trying to enter a building, doing/undoing rituals, taking clothes on/off, pattern walking, in/out chair, up/down stairs, may have to repeat a certain number of times."
		},
		{
			"number": 37,
			"text": "Evening up behaviors.* Examples: movement on right side up body has to be balanced with same movement on left side; adjusts height of stockings, tension of shoe laces; if touches something with one hand, has to touch with the other."
		},
		{
			"number": 38,
			"text": "Re-reading* or re-writing. Examples: doubt information that just read so re-reads it, written letters must look perfect. Distinguish from *dyslexia."
		},
		{
			"number": 39,
			"text": "Counting compulsions. Examples: counting things like ceiling or floor tiles, books in a bookcase, words in a sentence."
		},
		{
			"number": 40,
			"text": "Ritualized Activity of Daily Living routines. Example: may have to put clothes on in a certain order, can only go to bed after following an elaborate series of steps or having an exchange with parents, brush teeth in a ritualistic manner."
		},
		{
			"number": 41,
			"text": "Excessive religious rituals. Example: Repeating prayers or biblical passages an inordinate number of times; confessing minor or perceived moral wrong-doings."
		},
		{
			"number": 42,
			"text": "Ordering or arranging compulsions. Example: straightening possessions on a desktop, straightening pictures, arranging toys in a particular manner, or adjusting books in a bookcase."
		},
		{
			"number": 43,
			"text": "Repeating what someone else has said.* Example: word, phrase, or sound. *Distinguish from echolalia of Tourette’s Syndrome."
		},
		{
			"number": 44,
			"text": "Asking for reassurance. Example: repeatedly asking parent if they performed a routine correctly."
		},
		{
			"number": 45,
			"text": "Ritualized eating behaviors.* Examples: arrange or eat food in particular way or a specific order to avert a feared consequence other than gaining weight, as in *anorexia nervosa."
		},
		{
			"number": 46,
			"text": "Saves or collects useless items.* Examples: piles up old newspapers, school papers, collects useless objects. Bedroom can become obstacle course with piles of clutter. *Distinguish from hobbies and concern with objects of monetary or sentimental value. And, consider hoarding limits imposed by parents."
		},
		{
			"number": 47,
			"text": "Picks up objects that most people would pass by. Examples: shards of broken glass, rocks, pieces of paper with writing on them, old pencil nubs."
		},
		{
			"number": 48,
			"text": "Examines things that leave one’s possession. Examples: sifts through garbage, ritual for washing off dinner plates to separate waste from accidentally lost items; difficulty throwing out trash; repeatedly checks school backpack to make sure nothing was lost, repeatedly checks to make sure previous nights homework assignments are packed."
		},
		{
			"number": 49,
			"text": "Buys or hoards many unneeded items. Examples: keeps 20 pens with them at all times, stores an excessive number of batteries in case needed, etc. *May not be symptom of OCD unless behavior is excessive (e.g., wastes a lot of money, or accumulates closet or school locker full of unnecessary items.)."
		},
		{
			"number": 50,
			"text": "Need to tell, ask or confess things. Examples: confessing to sins or wrongs that didn't commit; feels must describe every detail so that nothing is left out; repeats the same question in different ways to make sure it was understood. Inflated sense of responsibility?"
		},
		{
			"number": 51,
			"text": "Need to do something until it feels \"just right.\" Examples: adjusts clothing, arranges possessions, repeats a behavior, until feels an internal signal that it’s OK. Has no specific feared consequences in mind."
		},
		{
			"number": 52,
			"text": "Need to touch, tap, or rub*. Examples: urge to touch or run finger along surfaces or edges, lightly touches other people; taps a certain number of times; rubs against soft materials. May be difficult to distinguish from complex motor tics of *Tourette’s Syndrome."
		},
		{
			"number": 53,
			"text": "Staring or blinking rituals*. Examples: child says he/she has to blink a certain number or times or stare to neutralize an obsession. May be difficult to distinguish from motor tics of * Tourette’s Syndrome."
		},
		{
			"number": 54,
			"text": "Superstitious behaviors. Examples: steps over sidewalk cracks, spits after having an unwanted thought; makes sure sentences never contain 13 words; makes sign of the cross before dialing area code for New Jersey."
		},
		{
			"number": 55,
			"text": "Mental rituals (other than checking or counting). Examples: silently reciting prayers or nonsense words to neutralize unwanted thoughts."
		},
		{
			"number": 56,
			"text": "Pervasive slowness. Extensive difficulty in starting, executing, and finishing a wide range of routines tasks. In extreme cases, may be unable to complete tasks without assistance and may become “paralyzed. *Distinguish from psychomotor retardation secondary to depression or a primary movement disorder."
		},
		{
			"number": 57,
			"text": "Ritualized avoidance. Examples: plans course on roadmap or with family member to stay certain distance from chemical factories."
		},
		{
			"number": 58,
			"text": "Active measures to avoid contact with contaminants or other feared objects. Examples: wears rubber gloves, doesn’t shake hands, has one clean and one dirty hand, won’t go near anyone who seems to have a cut, won’t sit down in a chair that has a red spot (possibly blood)."
		},
		{
			"number": 59,
			"text": "Avoids doing things, going places or being with people because of obsessions, or makes family members avoid these triggers."
		},
		{
			"number": 60,
			"text": "Avoids contact (or makes family avoid contact) with contaminated objects or people."
		},
		{
			"number": 61,
			"text": "Avoids handling sharp or dangerous objects, or operating vehicles or machinery such as cars or saws (or makes family avoid contact), out of concern might harm others."
		},
		{
			"number": 62,
			"text": "Avoids contact with people, children or animals because of unwanted impulses."
		},
		{
			"number": 63,
			"text": "Avoids talking to or writing to others for fear will say or write the wrong thing."
		},
		{
			"number": 64,
			"text": "Avoids watching TV, playing videogames, listening to radio or reading to shield from disturbing information."
		},
		{
			"number": 65,
			"text": "Avoids doing things, going places, or being with someone (or makes family avoid) that would trigger time consuming or onerous rituals (e.g., washing, dressing, etc.)."
		},
		{
			"number": 66,
			"text": "Avoids reading or writing because it may bring on rituals (e.g., re-reading, re-writing)."
		}
	],
	"items": [
		{
			"number": 1,
			"title": "Time Occupied By Obsessive Thoughts",
			"probes": "Q: “How much of your time is occupied by obsessive thoughts?” [When obsessions occur as brief, intermittent intrusions, it may be difficult to assess time occupied by them in terms of total hours. In such cases, posing item #2 first may help identify most appropriate response to item #1. Be sure to exclude ruminations and preoccupations that, unlike obsessions, are ego-syntonic and rational – albeit excessive.)]",
			"anchors": [
				"None.",
				"Mild, less than 1 hr/day.",
				"Moderate, 1 to 3 hrs/day.",
				"Severe, greater than 3 and up to 8 hrs/day.",
				"Very severe, greater than 8 and up to 12 hrs/day.",
				"Extreme, greater than 12 hrs/day, constant or nearly constant intrusions."
			]
		},
		{
			"number": 2,
			"title": "Obsession-Free Interval",
			"probes": "Q: “On average, what is the longest continuous period (or block) of time in which you do not have obsessive thoughts?” [Only consider time while awake. You can also ask:] “How frequently do the obsessive thoughts occur?”",
			"anchors": [
				"No symptoms.",
				"Long symptom-free interval, more than 8 consecutive hours/day symptom-free.",
				"Moderately long symptom-free interval, more than 3 and up to 8 consecutive hours/day symptom-free.",
				"Short symptom-free interval, from 1 to 3 consecutive hours/day symptom-free.",
				"Very short symptom-free interval, from less than 1 consecutive hour/day to a few minutes symptom-free; freedom from obsessions measured in minutes.",
				"Extremely short (or no) symptom-free interval, constant to near constant (less than a minute symptom-free); freedom from obsessions measured in seconds. May experience only momentary relief."
			]
		},
		{
			"number": 3,
			"title": "Degree Of Control Over Obsessive Thoughts",
			"probes": "Q: “How much control do you have over your obsessive thoughts? How successful are you in stopping or ignoring them? Can you get rid of them?”",
			"anchors": [
				"Complete control.",
				"Much control, usually able to stop or ignore obsessions.",
				"Moderate control, often able to stop or ignore obsessions with some effort and concentration.",
				"Some control, sometimes able to stop or ignore obsessions.",
				"Minimal or little control, infrequently able to stop or ignore obsessions, can only divert attention with difficulty.",
				"No control, experienced as completely involuntary, rarely able to even momentarily alter or let go of obsessive thinking."
			]
		},
		{
			"number": 4,
			"title": "Distress Associated With Obsessive Thoughts",
			"probes": "Q: “How much do your obsessive thoughts bother or upset you?” [In most cases, distress is equated with anxiety; however, patients may report that their obsessions are \"disturbing\" or “upsetting” but deny \"anxiety.\" Only rate distress that seems generated by obsessions, not generalized anxiety or anxiety associated with other conditions.]",
			"anchors": [
				"None.",
				"Mild, slightly disturbing.",
				"Moderate, definitely disturbing but manageable.",
				"Severe, sometimes to frequently the thoughts are highly disturbing and difficult to manage",
				"Very severe, most if not all thoughts are highly disturbing and difficult to manage.",
				"Extreme, overwhelming and disabling distress whenever a thought occurs."
			]
		},
		{
			"number": 5,
			"title": "Interference Due To Obsessive Thoughts",
			"probes": "Q: “How much do your obsessive thoughts interfere with performance in school/the classroom, getting along with other kids, or in your family?” [If currently not attending school, determine how much performance would be affected if patient were in school.] “(Has your child or) Have you been avoiding doing anything, going any place, or being with anyone because of your obsessions?” [Evaluate impact of avoidance on functioning.]",
			"anchors": [
				"None. No deliberate avoidance.",
				"Mild, slight interference with social, family, or school activities, but overall performance not impaired. Minimal avoidance.",
				"Moderate, definite interference with social, family, or school functioning, but still manageable. Some avoidance.",
				"Severe, causes significant impairment in one or more (but not all) domains (or aspects) of functioning; e.g., OK at school, but social life on hold or considerable family interference. Much avoidance, but at least one area of functioning is relatively free from avoidance.",
				"Very severe, causes significant impairment in ALL major areas of functioning. Leads narrowly circumscribed existence.",
				"Extreme, incapacitating. May be housebound or missed considerable amount of school such that has to repeat a grade."
			]
		},
		{
			"number": 6,
			"title": "Time Spent Performing Compulsive Behaviors",
			"probes": "Q: “How much time do you spend performing compulsive behaviors?” [When rituals involving activities of daily living are chiefly present, ask:] “How much longer than most people does it take to complete routine activities because of your rituals?” [When compulsions occur as brief, intermittent behaviors, it may be difficult to assess time spent performing them in terms of total hours. In such cases, estimate time by determining how frequently they are performed. Consider both the number of times compulsions are performed and how much of the day is affected. When estimating frequency, count separate occurrences of compulsive behaviors, not number of repetitions. In most cases compulsions are observable behaviors (e.g., hand washing or refusing to shake hands), but some compulsions are covert (e.g., silent checking, praying or other mental rituals); these mental rituals should be rated as you would overt compulsions. “Active avoidance” (e.g., rule governed behaviors that ensure a minimum “safe” distance from contaminated areas or wearing a glove on one hand to keep it clean) like compulsions, can manifest as discrete behavioral acts, measurable in hours or by frequency, so should be rated on this item. “Passive avoidance”, on the other hand, may be difficult to quantify temporally; however, its relationship to compulsions and resultant impact on distress and functioning can be measured on items 9 and 10 respectively.",
			"anchors": [
				"None.",
				"Mild, spends less than 1 hr/day or occasional performance of compulsive behaviors.",
				"Moderate, spends from 1 to 3 hrs/day or frequent performance of compulsive behaviors.",
				"Severe, spends more than 3 and up to 8 hrs/day or very frequent performance of compulsive behaviors.",
				"Very severe, spends more than 8 and up to 12 hrs/day performing compulsive; majority of waking hours filled by rituals.",
				"Extreme, greater than 12 hrs/day performing compulsive behavior, constant or nearly constant performance of rituals."
			]
		},
		{
			"number": 7,
			"title": "Resistance Against Compulsions",
			"probes": "Q: “How much of an effort do you make to resist doing your compulsions?” [Only rate effort made to resist, not success or failure in actually controlling the compulsions. How much the patient resists the compulsions may or may not correlate with his ability to control them. Note that this item does not directly measure the severity of the compulsions; rather it rates a manifestation of health, i.e., the effort the patient makes to counteract the compulsions. Thus, the more the patient tries to resist, the less impaired is this aspect of his functioning. If the compulsions are minimal, the patient may not feel the need to resist them. In such cases, a rating of \"0\" should be given.]",
			"anchors": [
				"Makes an effort to always resist, or symptoms so minimal doesn't need to actively resist.",
				"Tries to resist most of the time.",
				"Makes moderate effort to resist.",
				"Makes some effort to resist.",
				"Yields to almost all compulsions without attempting to control them, but does so with some hesitation.",
				"Completely yields to all compulsions; experienced as almost involuntary."
			]
		},
		{
			"number": 8,
			"title": "Degree Of Control Over Compulsive Behavior",
			"probes": "Q: “How strong is the urge to perform the compulsions?” [Pause] “How much control do you have over your behaviors?” [In contrast to the preceding item on resistance, this item directly measures success or failure in controlling compulsions.]",
			"anchors": [
				"Complete control.",
				"Much control, usually able to resist compulsions.",
				"Moderate control, pressure to perform behavior, but often able to control it.",
				"Some control, strong drive to perform behaviors, sometimes able to control them.",
				"Minimal or little control, infrequently able to stop behaviors, once started, must be carried to completion; can only delay with difficulty.",
				"No control, drive to carry out compulsions experienced as completely involuntary and overpowering, rarely able to even momentarily delay activity."
			]
		},
		{
			"number": 9,
			"title": "Distress If Compulsive Behavior (Or Avoidance) Prevented",
			"probes": "Q: “How would you feel if you were prevented from performing your compulsion(s)?” [Pause] “How distressed would you become?” [Rate degree of distress patient would experience if performance of the ritual were prevented or suddenly interrupted without reassurance. Like compulsions, avoidance maneuvers can reduce distress; conversely, forced confrontation with avoided objects can engender distress. Ask similar questions about avoidance:] “How would you feel if you weren’t allowed to avoid?” [In most, but not all cases, performing compulsions reduces anxiety. In other cases, the compulsions themselves can be a source of distress when laborious or demanding; they can even be painful as in the case of washing with scalding hot water. In these cases, distress or discomfort produced by the compulsions can be taken into account when rating this item. Apart from these latter instances, this item can be viewed as an indirect measure of how dependent the individual is on compulsions or avoidance to keep distress in check.]",
			"anchors": [
				"None.",
				"Mild; becomes only slightly anxious if compulsions (or avoidance) prevented.",
				"Moderate; reports that anxiety definitely increases but remains manageable if compulsions (or avoidance) prevented.",
				"Severe; experiences marked anxiety if some compulsions (or avoidance) are prevented.",
				"Very severe; experiences marked anxiety if almost any compulsion (or avoidance) is prevented.",
				"Extreme; overwhelming anxiety from any attempt to delay or modify compulsions (or avoidance)."
			]
		},
		{
			"number": 10,
			"title": "Interference Due To Compulsions",
			"probes": "Q: “How much do your compulsive behaviors interfere with how you do in school, getting along with other kids, or in your family?” [If currently not working (or attending school), determine how much performance would be affected if patient were employed (or in school).] “Have you been avoiding doing anything, going any place, or being out of concern you will trigger the compulsions?” [Evaluate impact of avoidance on functioning. An example of avoidance relevant to assessment of compulsions is letting soiled clothes pile up instead of launching into an exhausting and prolonged laundry routine that will defy interruption.]",
			"anchors": [
				"None. No deliberate avoidance.",
				"Mild, slight interference with social, family, or school activities, but overall performance not impaired. Minimal avoidance.",
				"Moderate, definite interference with social, family, or school functioning, but still manageable. Some avoidance.",
				"Severe, causes significant impairment in one or more (but not all) domains (or aspects) of functioning; e.g., OK at school, but social life on hold or considerable family interference. Compulsions are noticeable to careful observers at times. Much avoidance, but at least one area of functioning is relatively free from avoidance.",
				"Very severe, causes significant impairment in ALL domains of functioning, e.g., social, family, and school performance. Compulsions are very difficult to disguise and are often apparent to others. Leads narrowly circumscribed existence.",
				"Extreme, incapacitating. Abnormal behaviors are virtually impossible to conceal. May be housebound."
			]
		}
	]
};

export const CY_BOCS_II_CHECKLIST = instrumentContent.checklist;
export const CY_BOCS_II_ITEMS = instrumentContent.items;

export const CY_BOCS_II_DOMAINS = [
	{ id: "obsession", type: "Obsession", title: "Obsessions", items: CY_BOCS_II_CHECKLIST.filter(item => item.number <= 29).map(item => `${String(item.number).padStart(2, "0")}. ${item.text}`) },
	{ id: "compulsion", type: "Compulsion", title: "Compulsions", items: CY_BOCS_II_CHECKLIST.filter(item => item.number >= 30 && item.number <= 58).map(item => `${item.number}. ${item.text}`) },
	{ id: "avoidance", type: "Avoidance", title: "Avoidance", items: CY_BOCS_II_CHECKLIST.filter(item => item.number >= 59).map(item => `${item.number}. ${item.text}`) },
];

export const CY_BOCS_II_ANCILLARY = [
	{
		"number": 11,
		"title": "Insight into obsessions and compulsions",
		"probes": "INSIGHT INTO OBSESSIONS AND COMPULSIONS Q: “Do you believe your concerns or behaviors are reasonable?” [Pause] “What do you think would happen if you did not perform the compulsion(s)? Are you convinced something would really happen?” [Rate patient's insight into the senselessness or excessiveness of his obsession(s) based on beliefs expressed at the time of the interview.]",
		"anchors": [
			"Excellent insight, fully rational",
			"Good insight. Readily acknowledges absurdity or excessiveness of thoughts or behaviors but does not seem completely convinced that there isn't something besides anxiety to be concerned about (i.e., has lingering doubts).",
			"Fair insight. Reluctantly admits thoughts or behavior seem unreasonable or excessive, but wavers. May have some unrealistic fears, but no fixed convictions.",
			"Poor insight. Maintains that thoughts or behaviors are not unreasonable or excessive, but acknowledges validity of contrary evidence (i.e., overvalued ideas present).",
			"Lacks insight, delusional. Definitely convinced that concerns and behavior are reasonable, unresponsive to contrary evidence."
		]
	},
	{
		"number": 12,
		"title": "Reliability",
		"probes": "RELIABILITY: Rate the overall reliability of the rating scores obtained. Factors that may affect reliability include the patient's and/or parent's cooperativeness and his/her natural ability to communicate. The type and severity of obsessive-compulsive symptoms present may interfere with the patient's concentration, attention, or freedom to speak spontaneously (e.g., the content of some obsessions may cause the patient to choose his words very carefully).",
		"anchors": [
			"Excellent, no reason to suspect data unreliable",
			"Good, factor(s) present that may adversely affect reliability",
			"Fair, factor(s) present that definitely reduce reliability",
			"Poor, very low reliability"
		]
	},
	{
		"number": 13,
		"title": "Global severity",
		"probes": "GLOBAL SEVERITY: Interviewer's judgment of the overall severity of the child’s illness. Rated from 0 (no illness) to 6 (most severe patient seen). [Consider the degree of distress reported by the patient, the symptoms observed, and the functional impairment reported. Your judgment is required both in averaging this data as well as weighing the reliability or accuracy of the data obtained and should be based on information obtained during the interview.]",
		"anchors": [
			"No illness",
			"Illness slight, doubtful, transient; no functional impairment",
			"Mild symptoms, little functional impairment",
			"Moderate symptoms, functions with effort",
			"Moderate - Severe symptoms, limited functioning",
			"Severe symptoms, functions mainly with assistance",
			"Extremely Severe symptoms, completely nonfunctional"
		]
	},
	{
		"number": 14,
		"title": "Global improvement",
		"followUpOnly": true,
		"probes": "GLOBAL IMPROVEMENT: Rate total overall improvement present SINCE THE INITIAL RATING whether or not, in your judgment, it is due to treatment effects.",
		"anchors": [
			"Very much worse",
			"Much worse",
			"Minimally worse",
			"No change",
			"Minimally improved",
			"Much improved",
			"Very much improved"
		]
	}
];

function field(id, type, title, extra = {}) {
	return {id, type, title, ...extra};
}

export function createCyBocsSecondEditionConfig() {
	const fields = [
		field("administrationDate", "DATE", "Administration date", {isRequired: true}),
		field("childReport", "MULTILINE", "Child interview notes"),
		field("parentReport", "MULTILINE", "Caregiver interview notes"),
		field("clinicianObservation", "MULTILINE", "Clinician observation and report discrepancies"),
		field("definitions", "TITLE", "Interview definitions", {description: "OBSESSIONS are thoughts, ideas or pictures that keep coming into your mind even though you do not want them. Example: recurrent thoughts that you might make a loved one ill by not washing your hands carefully. COMPULSIONS are things you feel you have to do, even when they do not make sense; stopping may bring worry, anger, or frustration. Example: repeated handwashing or checking locks; mental counting can also be a compulsion. AVOIDANCE of feared situations may prevent contact with OCD triggers. Example: avoiding a school bathroom for fear of contamination. Confirm that child and caregiver understand these distinctions."}),
	];
	for (const domain of CY_BOCS_II_DOMAINS) {
		fields.push(field(`${domain.id}Title`, "TITLE", domain.title, {description: "Current means within the last 30 days; past means before that. Only endorse clinically judged OCD symptoms. * Items need differential diagnosis review."}));
		fields.push(field(`${domain.id}Reviewed`, "RADIOBUTTONS", "Checklist reviewed", {isRequired: true, answerOptions: ["Reviewed"], answerOptionsScoring: [0]}));
		for (const period of ["Current", "Past", "Principal"]) {
			fields.push(field(`${domain.id}${period}`, "CHECKBOXES", period, {answerOptions: domain.items, answerOptionsScoring: domain.items.map(() => 0)}));
		}
	}
	for (const domain of CY_BOCS_II_DOMAINS) {
		fields.push(field(`${domain.id}TargetsTitle`, "TITLE", `Target ${domain.title.toLowerCase()}`, {description: "Describe up to three prominent symptoms and details useful for follow-up."}));
		for (let number = 1; number <= 3; number++) fields.push(field(`${domain.id}Target${number}`, "TEXT", `Target ${number}`));
	}
	for (const item of CY_BOCS_II_ITEMS) {
		fields.push(field(`rating${item.number}`, "RADIOBUTTONS", `${item.number}. ${item.title}`, {isRequired: true, answerOptions: item.anchors.map((anchor, index) => `${index} — ${anchor}`), answerOptionsScoring: item.anchors.map(() => 0)}));
	}
	return {
		title: "Children's Yale-Brown Obsessive-Compulsive Scale Second Edition (CY-BOCS-II)",
		instructions: "Clinician-rated interview. Rate the average occurrence during the prior week through today. Review child and caregiver reports and make a final consensus rating. Active or ritualized OCD avoidance can be rated with compulsions; relevant passive avoidance informs interference and distress. Exclude generalized lifestyle avoidance and avoidance due to other conditions.",
		purpose: "baseline",
		instrumentIdentity: CY_BOCS_II_IDENTITY,
		assessment: {
			interviewGuidance: "Rate the average during the prior week through today. On follow-up, review target obsessions before item 1 and target compulsions before item 6. Active or ritualized OCD avoidance is rated like compulsions; relevant passive avoidance informs items 5, 9, and 10. Exclude generalized lifestyle avoidance and avoidance due to another condition.",
			dateFieldId: "administrationDate",
			sourceFields: [{id: "childReport", title: "Child report"}, {id: "parentReport", title: "Caregiver report"}, {id: "clinicianObservation", title: "Clinician observation and discrepancies"}],
			ratingMax: 5,
			domains: CY_BOCS_II_DOMAINS.map(domain => ({...domain, reviewedFieldId: `${domain.id}Reviewed`, currentFieldId: `${domain.id}Current`, pastFieldId: `${domain.id}Past`, principalFieldId: `${domain.id}Principal`})),
			items: CY_BOCS_II_ITEMS.map(item => ({...item, fieldId: `rating${item.number}`})),
			ancillaryItems: CY_BOCS_II_ANCILLARY.map(item => ({...item, fieldId: `ancillary${item.number}`})),
			targetGroups: CY_BOCS_II_DOMAINS.map(domain => ({type: domain.type, fieldIds: [1, 2, 3].map(number => `${domain.id}Target${number}`)})),
			ratingGroups: [{id: "obsession", title: "Obsessions", itemIds: [1, 2, 3, 4, 5].map(number => `rating${number}`)}, {id: "compulsion", title: "Compulsions", itemIds: [6, 7, 8, 9, 10].map(number => `rating${number}`)}],
		},
		fields,
	};
}

export function getCyBocsSecondEditionScores(answers = {}) {
	const scores = getClinicianAssessmentScores(createCyBocsSecondEditionConfig(), answers);
	return {obsession: scores.subtotals.obsession, compulsion: scores.subtotals.compulsion, total: scores.total, missingItems: scores.missingItems, missingDomains: scores.missingDomains};
}

export function createCyBocsSecondEditionDemoPayload() {
	const answers = {administrationDate: "2026-10-21", childReport: "child reports checking school materials.", parentReport: "caregiver reports more frequent checking at home.", clinicianObservation: "Jordan Lee reviews the difference in reports."};
	for (const domain of CY_BOCS_II_DOMAINS) answers[`${domain.id}Reviewed`] = "Reviewed";
	answers.compulsionCurrent = [CY_BOCS_II_DOMAINS[1].items[2]];
	answers.compulsionPrincipal = [CY_BOCS_II_DOMAINS[1].items[2]];
	answers.compulsionTarget1 = "Checking school materials";
	const ratings = [1, 2, 3, 4, 5, 0, 1, null, 3, 4];
	for (const item of CY_BOCS_II_ITEMS) if (ratings[item.number - 1] !== null) answers[`rating${item.number}`] = ratings[item.number - 1];
	return {answers};
}
